module.exports = __webpack_public_path__ + "img/empty-company-logo.4d963526.svg";